// Module
var code = "<div class=pureSelectContainer> <div class=pureSelectValue> <span class=pureSelectActualVal></span> </div> <div class=pureSelectOptionsContainer></div> </div>";
// Exports
module.exports = code;